import './recepcion_orden_compra.css'
export { default as ListadoRecepcionOrdenCompra } from "./Listado"
export { default as RecepcionOrdenCompra } from "./Recepcion"
export { default as DetalleRecepcionOrdenCompra } from "./Detalle"